module.exports = __webpack_public_path__ + "img/arrow-send.47cd222f.svg";